module.exports = __webpack_public_path__ + "static/media/video_rectangle_icon.58b284b8.svg";